
import { useRef } from "react"
import BasePlane from "./components/BasePlane.jsx"

export default function Experience()
{


    return(
        <group>
            <BasePlane
                scale={ 1.3 }
            />
        </group>
    )
    
}